<template>
  <v-container
    style="min-height: 590px"
    class="text--primary"
    fluid
  >
    <h2>{{ $t('label.sections') }}</h2>
    <p>
      {{ $t('help.onboarding.sections_1') }}
    </p>
    <p>
      <i18n
        path="help.onboarding.sections_2"
        tag="p"
      >
        <span class="font-weight-medium">{{ $t('title.settings') }}→{{ $t('title.sections') }}</span>.
      </i18n>
    </p>
    <h2>{{ $t('label.tables') }}</h2>
    <p>
      {{ $t('help.onboarding.tables') }}
    </p>

    <v-row justify="center">
      <v-col cols="12">
        <v-row
          v-for="(t,i) in tabs"
          :key="i"
        >
          <v-col
            v-if="i > 0"
            cols="12"
            class="pt-5 pb-0"
          >
            <v-divider />
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="pb-0"
          >
            <validation-provider
              v-slot="{ errors }"
              rules="required|min:2|max:255"
            >
              <v-text-field
                v-model="t.name"
                :label="$t('label.section_name')"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="text-center mt-0 pb-0 mt-sm-3 px-1"
          >
            <v-btn
              :block="$vuetify.breakpoint.smAndDown"
              :disabled="t === null"
              outlined
              color="primary"
              @click="setupTables(t)"
            >
              {{ $t('button.setup_tables') }}
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="text-center mt-0 pb-0 mt-sm-3 px-1"
          >
            <v-btn
              :disabled="t === null"
              :block="$vuetify.breakpoint.smAndDown"
              outlined
              color="primary"
              @click="setupFloorplan(t)"
            >
              {{ $t('button.floorplan') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <tables-dialog
      :visible="tabItemsDialog"
      :tab="tab"
      @close="closeDialogs()"
    />
    <floorplan-edit-dialog
      :visible="floorplanDialog"
      :tab="tab"
      @close="closeDialogs()"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import TablesDialog from '@/components/views/settings/TablesDialog.vue';
import FloorplanEditDialog from '@/components/views/settings/FloorplanEditDialog.vue';
import Tab from '@/model/Tab';
import { performSaveAction } from '@/services/vue-utils';
import { cloneModel, isModelEqualToModel } from '@/model/model-utils';

export default Vue.extend({
  name: 'WelcomeStepTables',
  components: { TablesDialog, FloorplanEditDialog },
  props: { },
  data() {
    return {
      tabItemsDialog: false,
      floorplanDialog: false,
      tab: null as Tab | null,
      tabs: [] as Tab[],
      oldTabs: [] as Tab[],
      unwatch: Function as (() => void),

    };
  },
  computed: {
    isChanged(): boolean {
      return !isModelEqualToModel(this.tabs, this.oldTabs);
    },
  },
  watch: { },
  mounted() {
    this.reset();
  },
  created() {
    this.unwatch = this.$tstore.watch((state, getters) => getters.isLoaded, (newValue, oldValue) => { this.reset(); });
  },
  beforeDestroy() {
    this.unwatch();
  },

  methods: {
    setupTables(tab: Tab) {
      this.tab = tab;
      this.tabItemsDialog = true;
    },
    setupFloorplan(tab: Tab) {
      this.tab = tab;
      this.floorplanDialog = true;
    },
    closeDialogs() {
      this.tabItemsDialog = false;
      this.floorplanDialog = false;
    },
    // eslint-disable-next-line vue/no-unused-properties
    async submit() {
      if (!this.isChanged) {
        this.$emit('advance');
        return;
      }

      const entities = this.tabs;
      const ok = await performSaveAction(
        undefined,
        async () => this.$tstore.dispatch('sendTabs', { entities }),
      );
      if (!ok) return;

      this.reset();
      this.$emit('advance');
    },
    reset() {
      const { tabs } = this.$tstore.state.settings;
      this.tabs = tabs.map((o) => cloneModel(o));
      this.oldTabs = tabs;
    },
  },
});
</script>
